import { DayOfWeek } from '../../../models/DayOfWeek';
import { OpeningTimeDay } from '../../../models/OpeningTimeDay';
import React from 'react';

interface OpeningHoursProps {
  openingTimes: Record<string, OpeningTimeDay>;
}

export const OpeningHours: React.FC<OpeningHoursProps> = ({ openingTimes }) => {
  const days = Object.values(DayOfWeek);

  return (
    <div className="mt-6">
      <div className="flex items-center mb-4">
        <i className="material-icons">schedule</i>
        <span className="ml-2 font-medium">Opening Hours</span>
      </div>
      
      <div className="space-y-2">
        {days.map((day) => {
          const openingTime = openingTimes[day];
          return (
            <div key={day} className="flex">
              <span className="w-12 capitalize">
                {day.toLowerCase()}
              </span>
              <span className="font-medium">
                {openingTime?.formattedOpeningTimeSlots || "Closed"}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
